// extracted by mini-css-extract-plugin
export var modalFooter = "_nr-0";